import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useParams, useNavigate } from 'react-router-dom'
import Axios from 'axios'
import { toastSuccess, toastError } from '../../components/swal/toast'
import Version from '../../version'

export default function ResetPassword() {
    const { t } = useTranslation()
    const { id, tokenresetpassword } = useParams()
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [submitting, setSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (password !== confirmPassword) {
            toastError(t('passwordreset.passwordsdoesnotmatch'))
            return
        }
        setSubmitting(true)
        try {
            await Axios.put(process.env.REACT_APP_DB_ADDRESS + `/api/forgot/reset/${id}/${tokenresetpassword}`, { password })
            toastSuccess(t('forgot.restoresuccess'))
            navigate('/')
        } catch (error) {
            toastError(t('passwordreset.changeerror'))
        }
        setSubmitting(false)
    }

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-header'>
                        <h3 className='fw-bold mb-0' style={{ color: '#fff' }}>{t('passwordreset.question')}</h3>
                        <p className='mt-2 mb-0' style={{ color: 'rgba(255,255,255,0.8)' }}>{t('passwordreset.help')}</p>
                    </div>
                    <div className='login-card-body'>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('passwordreset.new_password')}</Form.Label>
                                <Form.Control type='password' value={password} onChange={(e) => setPassword(e.target.value)} className='login-input' required />
                            </Form.Group>
                            <Form.Group className='mb-3'>
                                <Form.Label>{t('passwordreset.confirm_password')}</Form.Label>
                                <Form.Control type='password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className='login-input' required />
                            </Form.Group>
                            <Button variant='danger' type='submit' className='w-100 login-submit-btn' disabled={submitting}>
                                {submitting ? <span className="spinner-border spinner-border-sm"></span> : t('passwordreset.submit')}
                            </Button>
                        </Form>
                    </div>
                </div>
                <div className='text-center' style={{ marginTop: '20px' }}><Version /></div>
            </div>
        </div>
    )
}
